import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/tabelapreco?${serialize(filtros)}`, { tela: 'tabela_preco' })
}

export async function get (id) {
  return httpAuth.get(`/tabelapreco/${id}`, { tela: 'tabela_preco' })
}

export async function add (dados) {
  return httpAuth.post(`/tabelapreco`, dados, { funcionalidade: 'tabela_preco_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/tabelapreco/${id}`, dados, { funcionalidade: 'tabela_preco_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/tabelapreco/${id}`, { funcionalidade: 'tabela_preco_excluir' })
}
